export default __webpack_public_path__ + "assets/afrl-logo.f1b5c00d.png";